export const webhookTypes = {
  FETCH_WEBHOOKS_START: 'FETCH_WEBHOOKS_START',
  FETCH_WEBHOOK_START: 'FETCH_WEBHOOK_START',
  EDIT_WEBHOOK_START: 'EDIT_WEBHOOK_START',
  SET_ON_EDIT_WEBHOOK: 'SET_ON_EDIT_WEBHOOK',
  SET_WEBHOOKS: 'SET_WEBHOOKS',
  ADD_WEBHOOK: 'ADD_WEBHOOK',
  TOGGLE_WEBHOOK_ENABLE: 'TOGGLE_WEBHOOK_ENABLE',
  SET_WEBHOOK_STATUS: 'SET_WEBHOOK_STATUS',
  SET_NEW_WEBHOOK: 'SET_NEW_WEBHOOK',
  LOADING_WEBHOOKS: 'LOADING_WEBHOOKS',
  SET_WEBHOOK_STATUS_LOADING: 'SET_WEBHOOK_STATUS_LOADING',
};
